/**
 * Enable runtime while auth session is known active.
 * During cold-start auth restore (authReady=false), keep runtime warm to avoid
 * briefly stopping background service between launches.
 */
export function shouldEnableOrderAlertRuntime(
  authReady: boolean,
  hasAuthenticatedUser: boolean,
): boolean {
  return hasAuthenticatedUser || !authReady
}

/**
 * Stop runtime only after auth has definitively resolved with no user.
 */
export function shouldStopOrderAlertRuntime(
  authReady: boolean,
  hasAuthenticatedUser: boolean,
): boolean {
  return authReady && !hasAuthenticatedUser
}
